type CallbackFunctionType = (element: HTMLElement) => void

const canObserveIntersection: boolean = 'IntersectionObserver' in window

/**
 * Observe the visibility of a dom element and call a function when visibile.
 * Returns false if intersection observer is not supported by the browser.
 * @param element The dom element to observe the intersection of
 * @param callback The method to call
 */
function observeIntersection(element: HTMLElement, callback: CallbackFunctionType): boolean {
  if (canObserveIntersection) {
    const lazyImageObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry: IntersectionObserverEntry) => {
        if (entry.isIntersecting) {
          const target = entry.target
          observer.unobserve(target)
          callback(element)
        }
      })
    })
    lazyImageObserver.observe(element)
    return true
  }
  return false
}

export { observeIntersection, canObserveIntersection }
